import { HttpClient } from '../common/httpClient';
import { InvoicePageData } from 'src/types/invoice';

export class ViberInvoicesApi {
  constructor(private readonly httpClient: HttpClient) { }

  async getAll(url: string): Promise<InvoicePageData> {
   return await this.httpClient.get(`${url}`)
  }

  async update(tenantId: string, id: string, status: string): Promise<void> {
    await this.httpClient.put(`/invoices/${tenantId}/${id}/${status}`, {});
  }

  async send(tenantId: string, id: string): Promise<void> {
    await this.httpClient.get(`/invoices/${tenantId}/resend/${id}`);
  }

}